import { useMemo } from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { UBORoles } from '@Store/index';
import { getBusinessOwnersQueryDataOptions } from '../api/ownersCenter.api';
import { getBusinessOwnerData } from '../api/util';

export const useGetBusinessOwners = () => {
  const { businessExternalId, isEmbedded, customerId } = getBusinessOwnerData();
  const { data } = useSuspenseQuery(
    getBusinessOwnersQueryDataOptions({
      businessExternalId: businessExternalId ?? '',
      isEmbedded,
      customerId: customerId!,
    })
  );

  const businessOwners = useMemo(
    () => data.filter((ubo) => ubo.role !== UBORoles.PRIMARY_OWNER),
    [data]
  );
  const mainOwner = useMemo(() => data.find((ubo) => ubo.role === UBORoles.PRIMARY_OWNER)!, [data]);
  return { businessOwners, mainOwner };
};
